export default __webpack_public_path__ + "static/media/partner-eizper.b74f63ab.png";